<div class="backDrop center white" *ngIf="visible$ | async">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="dialog-body">
                <div class="icon-div">
                    <i class="far fa-info-circle fa-4x"></i>
                </div>
                <div class="message-row">
                    <div>Please specify what kind of special data load you would like to perform. Comma separated filter values can be provided for certain properties in certain sources.</div>
                </div>
                <div *ngFor="let filter of config.filters" class="option-row">
                    <label>{{filter.caption}}</label>
                    <dx-text-box [(ngModel)]="filter.value"></dx-text-box>
                </div>
                <div class="option-row" [hidden]="!config.saveAsMockData">
                    <label>Mockdata Name</label>
                    <dx-text-box [(ngModel)]="config.mockdataName"></dx-text-box>
                </div>
                <div class="option-row" [hidden]="!config.saveAsMockData">
                    <label>Mockdata Monday Item</label>
                    <dx-text-box [(ngModel)]="config.mockdataMondayItem"></dx-text-box>
                </div>
                <div class="checkbox-row">
                    <div *ngIf="is.isSuperadmin$ | async">
                        <dx-check-box [disabled]="!ls"
                            text="Save as mock data"
                            [value]="config.saveAsMockData"
                            (onValueChanged)="onSaveAsMockDataChanged($event)">
                        </dx-check-box>
                    </div>

                    <div>
                        <dx-check-box [disabled]="!ls"
                            text="Anonymize data"
                            [value]="config.anonymizeData"
                            (onValueChanged)="onAnonymizeDataChanged($event)">
                        </dx-check-box>
                    </div>

                    <div>
                        <dx-check-box [disabled]="!ls"
                            text="Expose source lines"
                            [value]="config.exposeSourceLines"
                            (onValueChanged)="onExposeSourceLinesChanged($event)">
                        </dx-check-box>
                    </div>

                    <div>
                        <dx-check-box [disabled]="!ls"
                            text="Download raw data"
                            [value]="config.downloadRawData"
                            (onValueChanged)="onDownloadRawDataChanged($event)">
                        </dx-check-box>
                    </div>
                </div>
            </div>
            <div class="dialog-footer">
                <button class="btn btn-primary" (click)="ok()" style="margin-bottom:5px">OK</button>
                <button class="btn btn-secondary" (click)="hide()" style="margin-bottom:5px">Cancel</button>
            </div>
        </div>
    </div>
</div>
